import { jsx as l } from "react/jsx-runtime";
import { useCallback as d } from "react";
import { useTranslation as w } from "../../../../hooks/useTranslation/index.js";
import { useDropdownContext as c } from "../../../../contexts/Dropdown/context.js";
import { Container as D } from "./style.js";
function y({
  children: m,
  title: t,
  shouldNotOpen: e = !1,
  onClick: o,
  ...s
}) {
  const { t: n } = w("common"), { isOpen: r, openDropdown: p, closeDropdown: a, triggerRef: f } = c(), i = d(
    () => r ? a() : p(),
    [a, r, p]
  ), u = d(
    (g) => {
      o == null || o(g), !e && i();
    },
    [o, e, i]
  );
  return /* @__PURE__ */ l(
    D,
    {
      ...s,
      ref: f,
      type: "button",
      onClick: u,
      title: t || n("dropdown-title"),
      "aria-haspopup": "true",
      "aria-label": t || n("dropdown-title"),
      "aria-expanded": r,
      "aria-controls": "dropdown-menu",
      children: m
    }
  );
}
export {
  y as DropdownTriggerButton
};
